import { Component } from '@angular/core';

@Component({
  selector: 'ui-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent {

}